/**
 * Base URL of the tenant's public site, as seen from the portal.
 *
 * In production this is the tenant's real domain. In dev (or any environment
 * with VITE_PREVIEW_BASE_URL set) it points at the locally running frontend,
 * so "View site" and draft-preview links don't send people to production.
 */
export function publicSiteBase(tenantDomain: string): string {
  const override = import.meta.env.VITE_PREVIEW_BASE_URL as string | undefined;
  if (override) return override;
  if (import.meta.env.DEV) return "http://localhost:3000";
  return tenantDomain.startsWith("http")
    ? tenantDomain
    : `https://${tenantDomain}`;
}
